export const GET_CALL_STICKY_COLUMNS = "GET_CALL_STICKY_COLUMNS";
export const GET_CALL_STICKY_COLUMNS_SUCCESS = "GET_CALL_STICKY_COLUMNS_SUCCESS";
export const GET_CALL_STICKY_COLUMNS_ERROR = "GET_CALL_STICKY_COLUMNS_ERROR";

export const UPDATE_CALL_STICKY_COLUMNS = "UPDATE_CALL_STICKY_COLUMNS";
export const UPDATE_CALL_STICKY_COLUMNS_SUCCESS = "UPDATE_CALL_STICKY_COLUMNS_SUCCESS";
export const UPDATE_CALL_STICKY_COLUMNS_ERROR = "UPDATE_CALL_STICKY_COLUMNS_ERROR";